import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { TextArea } from '../../../../components/form-elements/TextArea';
import { ProductionPaperworkOrderDocument } from '../../../../models/production/production-paperwork-order';

export const ProductionOrderPaperwork = () =>  {

    const [isOpen, setIsOpen] = React.useState(false);
    const [orderIds, setOrderIds] = React.useState('');
    const dispatch = useDispatch();
    
    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setOrderIds('');
        setIsOpen(false);
    };

    /**
     * Run the report
     */
    const runReport = () => {
        if (orderIds && orderIds.length > 0) {
            const idList = orderIds.replaceAll('\n',',');

            const req = new ProductionPaperworkOrderDocument(idList);
            dispatch(getDocumentHelper(req));
            onCloseClick();
        }
    };

    /**
     * Handler for changing the order id list.
     * @param e The new order id list 
     */
    const onOrderIdChange = (e : any) => {    
        setOrderIds(e.target.value);
    };

    return <React.Fragment>
        <div className="report-card-wrap blue">
            <div className="row">
                <div className="col">
                    <div className="row">
                        <div className="col">
                            <h3>Production Paperwork (Orders)</h3>
                            <p>Export production paperwork for a list of orders.</p>
                        </div>
                    </div>
                
                    <div className="row">
                        <div className="col">
                        <DialogTrigger
                            onClick={ onOpenClick }
                            text="Run Report" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Dialog
            open={ isOpen }
            className="report-dialog"
            onClose={ onCloseClick }
            maxWidth="md"
            aria-labelledby="form-dialog-title">

            <DialogHeader>
                <h1>Paperwork Export</h1>
            </DialogHeader>

            <DialogContent>
                <div className="row">
                    <div className="col">
                        <p>Provide a list order IDs, one per line, to include in the paperwork bundle.</p>
                    </div>
                </div>
                <div className="row justify-content-around">
                    <div className="col">
                        <TextArea
                            id="shipmentIds"
                            className="reporting-shipmentexport-textarea"
                            label="Order IDs"
                            allowReturn={ true }
                            value={ orderIds }
                            onChange={ onOrderIdChange } />
                    </div>
                </div>    
            </DialogContent>
            <DialogActions>
                <FlatButton
                    id="accountmateNoBtn"
                    text="Cancel"
                    classes="negative"
                    onBtnClick={ onCloseClick } />
                <FlatButton
                    id="accountmateYesBtn"
                    text="Go"
                    disable={ orderIds.length === 0 }
                    classes="positive"
                    onBtnClick={ runReport } />
            </DialogActions>
        </Dialog>
    </React.Fragment>;

};
